module.exports = __webpack_public_path__ + "img/Grafic (2).10318789.jpg";